module.exports = __webpack_public_path__ + "img/motor_no38.83872d34.jpg";